<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Stok Grupları</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-text-field v-model="search" append-icon="search" label="Ara" single-line hide-details></v-text-field>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="select"
        :items="items"
        item-value="id"
        item-text="value" 
        @change="initialize"
        hide-details
        label="Aktif/Pasif"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-btn color="primary" dark @click="initialize" class="mb-2">Ara</v-btn>
      <v-btn color="primary" dark class="mb-2" to="/stockGroup/detail">Yeni Ekle</v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="this.$store.state.progress"
      :rows-per-page-items="pageItems"
      :items="this.$store.state.stockGroups.all"
      :pagination.sync="pagination"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="px-0 text-xs-center"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td class="px-0 text-xs-center">{{ props.item.id }}</td>
        <td class="px-0 text-xs-center">{{ props.item.stock }}</td>
        <td class="px-0 text-xs-center">{{ props.item.productIds }}</td>
        <td class="px-0 text-xs-center" v-if="props.item.state==1">Aktif</td>
        <td class="px-0 text-xs-center" v-else>Pasif</td>
        <td class="px-0 text-xs-center">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  data: () => ({
    pagination: {
      sortBy: "name"
    },
    select: { id: -1, value: "Tümü" },
    selectCategory: { id: 0, value: "Tümü" },
    search: null,
    pageItems: [
      500,
      1000,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ],
    items: [
      { id: -1, value: "Tümü" },
      { id: false, value: "Pasif" },
      { id: true, value: "Aktif" }
    ],
      categoryItems: [
      { id: -1, value: "Tümü" },
      { id: 1, value: "çeyrek altın" },
      { id: 2, value: "yarım altın" },
      { id: 3, value: "tam altın" },
      { id: 4, value: "ata lira" },
      { id: 5, value: "24 ayar gram altın" },
      { id: 6, value: "22 ayar gram altın" },
      { id: 7, value: "Gremse ve Arma" },
      { id: 8, value: "Bilezik grubu" }
    ],
    headers: [
      {
        text: "Id",
        align: "left",
        value: "id"
      },
      { text: "Stok", value: "stock" },
      { text: "ProductIds", value: "productIds" },
      { text: "Durum", value: "state" },
      { text: "İşlem", value: "name", sortable: false }
    ]
  }),
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    //this.initialize();
  },

  methods: {
    async initialize() {
      await this.$store.dispatch("stockGroups/searchStockGroup", {
        search: this.search,
        state: this.select.id,
        categoryId: this.selectCategory.id,
      });
    },
    editItem(item) {
      // this.$router.push({ name: "stockGroup-detail", params: { id: item.id } });
      window.open("/stockGroup/detail/"+item.id, '_blank');
    },

    deleteItem(item) {
      confirm("Silmek İstediğinizden Emin Misiniz?") &&
        this.$store.dispatch("stockGroups/deleteStockGroup", item);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  },
  async mounted() {
    await this.initialize();
  }
};
</script>